module.exports = __webpack_public_path__ + "img/404.6c4c8b11.png";